var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserBlacklisted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2172_393904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3638 9.27246H6.54565C3.23195 9.27246 0.545654 11.9588 0.545654 15.2725V37.0906C0.545654 40.4043 3.23195 43.0906 6.54565 43.0906H28.3638C31.6775 43.0906 34.3638 40.4043 34.3638 37.0906V15.2725C34.3638 11.9588 31.6775 9.27246 28.3638 9.27246Z",
    stroke: "#3583EE",
    strokeWidth: 1.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6701 19.6376C23.6701 22.9394 21.027 25.5837 17.7247 25.5837C14.4234 25.5837 11.7792 22.9393 11.7792 19.6376C11.7792 16.3361 14.4232 13.6928 17.7247 13.6928C21.0271 13.6928 23.6701 16.336 23.6701 19.6376Z",
    fill: "#3583EE",
    stroke: "#3583EE",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7245 28.4196C19.8522 28.4196 21.493 27.8435 22.9779 26.9401C23.8988 27.2889 24.6864 27.7404 25.3615 28.4022C26.1015 29.1275 26.739 30.1374 27.2514 31.6206C27.6105 32.66 27.5196 33.5401 27.1403 34.2947C26.7518 35.0672 26.0349 35.7575 25.0632 36.3378C23.1137 37.502 20.2951 38.1287 17.7245 38.1287C15.1411 38.1287 12.3958 37.4925 10.5221 36.3281C9.58903 35.7482 8.90757 35.0599 8.54386 34.2907C8.18765 33.5373 8.11209 32.6575 8.47284 31.6221C9.38189 29.0131 10.6539 27.6494 12.4926 26.9353C14.1238 27.8243 15.5668 28.4196 17.7245 28.4196Z",
    fill: "#3583EE",
    stroke: "#3583EE",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6369 17.455C36.4569 17.455 40.3642 13.5477 40.3642 8.72776C40.3642 3.90782 36.4569 0.000488281 31.6369 0.000488281C26.817 0.000488281 22.9097 3.90782 22.9097 8.72776C22.9097 13.5477 26.817 17.455 31.6369 17.455Z",
    fill: "url(#paint0_linear_2172_393904)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6364 13.7343C34.4024 13.7343 36.6447 11.492 36.6447 8.72604C36.6447 5.96005 34.4024 3.71777 31.6364 3.71777C28.8705 3.71777 26.6282 5.96005 26.6282 8.72604C26.6282 11.492 28.8705 13.7343 31.6364 13.7343Z",
    fill: "url(#paint1_linear_2172_393904)",
    stroke: "white",
    strokeWidth: 1.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2544 12.6966L31.6345 8.72964L34.0147 4.7627",
    stroke: "white",
    strokeWidth: 1.09091
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2172_393904",
    x1: 42.8577,
    y1: -2.49301,
    x2: 26.0265,
    y2: 13.7147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A00404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984275,
    stopColor: "#FF4343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FF4343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2172_393904",
    x1: 38.7769,
    y1: 1.58555,
    x2: 28.0662,
    y2: 11.8996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A00404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984275,
    stopColor: "#FF4343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FF4343"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2172_393904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.3636,
    height: 43.6364,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserBlacklisted);
export default __webpack_public_path__ + "static/media/icon-user-blacklisted.d10e35b339b0d0f29fd4e12f03ce2f90.svg";
export { ForwardRef as ReactComponent };